import { Theme } from "@emotion/react"
import { Box, Button, CircularProgress, SvgIconTypeMap, SxProps } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import React from "react"
import { customPalette } from "../../../theme"

interface IProps {
  label: string
  sx?: SxProps<Theme>
  icon?: OverridableComponent<SvgIconTypeMap<unknown, "svg">>
  disabled?: boolean
  isSubmitting?: boolean

  onClick(): void
}

export function BaseButton({ onClick, label, sx, icon: Icon, disabled, isSubmitting }: Readonly<IProps>): React.JSX.Element {
  return isSubmitting ? (
    <Box sx={{ pl: 5, pr: 5 }}>
      <CircularProgress />
    </Box>
  ) : (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: customPalette.lightGreen8,
        color: customPalette.mediumGreen3,
        gap: 1,
        ...sx,
      }}>
      {isSubmitting ? (
        <CircularProgress size={24} sx={{ color: customPalette.mainGreen5 }} />
      ) : (
        <>
          {Icon && <Icon />}
          {label}
        </>
      )}
    </Button>
  )
}
